import { render, staticRenderFns } from "./FollowOurProject.vue?vue&type=template&id=38f94418&scoped=true"
import script from "./FollowOurProject.vue?vue&type=script&lang=js"
export * from "./FollowOurProject.vue?vue&type=script&lang=js"
import style0 from "./FollowOurProject.vue?vue&type=style&index=0&id=38f94418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f94418",
  null
  
)

export default component.exports